module.exports = __webpack_public_path__ + "ay.no1.84872169.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ay.no1.jpg
// module id = fi8G
// module chunks = 0